import { LIST_GROUPS } from '../../bridge-methods';
import { getAsyncReducerWithModify } from '../../bridge-async-modifier';

export default getAsyncReducerWithModify({
  fetchKey: LIST_GROUPS,
  appendNode: 'content',
  itemParam: 'id',
});



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/groups/list/reducer.js